<div class="team-section container py-5 component-card">
  <div class="text-center mb-5">
  <h2 class="main-title" [innerHTML]="data.title"></h2>
    <h5 class="team-description" [innerHTML]="data.description"></h5>
  </div>

  <div class="row justify-content-center">
    <div
      *ngFor="let member of data.team"
      class="col-6 col-md-4 col-lg-3 text-center team-member mb-4"
    >
      <div class="image-wrapper mx-auto mb-3">
        <img
          class="person-img"
          [src]="member.imagesrc"
          [alt]="member.name + ' ' + member.position"
        />
      </div>
      <h4 class="name">{{ member.name }}</h4>
      <h6 class="position">{{ member.position }}</h6>
    </div>
  </div>
</div>
